<template>
  <form v-on:submit="create" method="post">
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <LabelRequiredField label="Nome" />
        <input
          type="text"
          ref="autofocus"
          v-model="name"
          class="form-control"
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <WarningRequiredFields />
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
        <v-btn :disabled="loading" type="submit" class="btn-save">
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "Carregando" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Create",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },

  data() {
    return {
      name: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      this.name = "";
      this.errors = [];
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loading = true;

        const { name } = this;

        let params = { name };

        const response = await api.post(
          "/rest-home/service-charge-type/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>